import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DepositNotes } from "@app/models/deposit-notes";
import { DepositNotesService } from "@app/services/deposit-notes.service";

@Component({
    selector: "app-deposit-note-node",
    templateUrl: "./deposit-note-node.component.html",
    styleUrls: ["./deposit-note-node.component.css"],
    standalone: false
})
export class DepositNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() depositNotes: Array<DepositNotes>;
  @Input() selectedDepositNotes: Array<DepositNotes>;
  @Output() onAddDepositNote = new EventEmitter<DepositNotes>();
  @Output() onDeleteDepositNote = new EventEmitter<DepositNotes>();

  constructor(private depositNoteService: DepositNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addDepositNote(item);
    } else {
      this.deleteDepositNote(item);
    }
  }

  addDepositNote(item) {
    this.onAddDepositNote.emit(item);
  }

  deleteDepositNote(item) {
    this.onDeleteDepositNote.emit(item);
  }

  isSelectedDepositNote(item: DepositNotes): boolean {
    return !!item && !!this.selectedDepositNotes?.some((note) => note?.id === item.id);
  }

  isIndeterminate(item: DepositNotes): boolean {
    return !!item?.subDepositNotes?.length && !this.isSelectedDepositNote(item)
      && item.subDepositNotes.some((child) => this.isSelectedDepositNote(child) || this.hasSelectedDescendant(child));
  }

  isExpanded(item: DepositNotes): boolean {
    return this.isSelectedDepositNote(item) || this.hasSelectedDescendant(item);
  }

  private hasSelectedDescendant(item: DepositNotes): boolean {
    return !!item?.subDepositNotes?.some((child) => this.isSelectedDepositNote(child) || this.hasSelectedDescendant(child));
  }
}
